import { OptionItem } from '@/models/common/option-item';

export type ConditionListItem = OptionItem

export enum ConditionListValueProperty {
  AND = 'and',
  OR = 'or',
}
